import { v4 as uuid } from 'uuid';
import './OrganizationLoader.scss';
const OrganizationLoader = () => {

  const optionsTabs = [
    { id: 1, name: 'General' },
    { id: 2, name: 'Cuenta' },
    { id: 3, name: 'Facturación' },
    { id: 4, name: 'Herramientas' },
    { id: 5, name: 'Cupones' },
    { id: 6, name: 'Configuración' }
  ];
  
  return (
    <div id="organizationLoader">
      <div className="orgDetailsHeader">
        <section className="leftSection">
          <div className="nameAndId">
            <div className="organizationName">
              <div className="h-6 w-28 animationLoader rounded-sm" />
            </div>
            <div className="organizationId">ID: </div>
          </div>
          <div className="tabsContainer">
            {optionsTabs &&
              optionsTabs.length > 0 &&
              optionsTabs.map(item => {
                return <div key={`key-id-tab-${item.id}`} className="tab generalTab  noSelectTab animationLoader" />;
              })}
          </div>
        </section>
        <section className="rightSection">
          <div className={'organizationState pending animationLoader'}></div>
          <div className="registrationDateContainer">
            <label className="label disabled">Fecha de registro</label>
            <div className="registrationDateLoader animationLoader" />
          </div>
        </section>
      </div>
      <div className="orgDataSection">
        <div className="orgDataTitle">Información de la empresa</div>
        <div className="dataContainer">
          <div className="organizationNameContainer">
            <div className="label disabled">Nombre de la empresa</div>
            <input type="text" className="inputElement animationLoader" disabled />
          </div>
          <div className="organizationBusinessNameContainer">
            <div className="label disabled">Razón social</div>
            <input type="text" className="inputElement animationLoader" disabled />
          </div>
          <div className="countryAndTaxNumberContainer">
            <div className="country">
              <div className="label disabled">País*</div>
              <div className="flagContainer animationLoader" />
            </div>
            <div className="taxNumber">
              <div className="label disabled">Número de identificación fiscal*</div>
              <input type="text" className="inputElement animationLoader" disabled />
            </div>
          </div>
        </div>
        <div className="dataContainer extraContainer">
          <div className="organizationNameContainer minSize">
            <div className="label disabled">Empleados creados</div>
            <input type="text" className="inputElement animationLoader" disabled />
          </div>
          <div className="organizationBusinessNameContainer minSize">
            <div className="label disabled">Herramientas cargadas </div>
            <input type="text" className="inputElement animationLoader" disabled />
          </div>
        </div>
        <div className="activateSubscription">
          <div className="titleSubscription">Suscripcion Plataforma</div>
          <div className="containerOptions">
            <div className="checkOption">
              <div className="checkcontainer">
                <div className="noSelectContainerLoader animationLoader" />
              </div>
              <div className="textContainer ">
                <div className="h-3.5 w-6 animationLoader rounded-sm" />
              </div>
            </div>
            <div className="checkOption">
              <div className="checkcontainer">
                <div className="noSelectContainerLoader animationLoader" />
              </div>
              <div className="textContainer ">
                <div className="h-3.5 w-6 animationLoader rounded-sm" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="orgUsersSection">
        <h2 className="orgUsersTitle">Información del usuario registrado</h2>
        <div className="usersContainer">
          {optionsTabs.map(() => {
            return (
              <div className="userInformationLoader" key={uuid()}>
                <div className="roleContainer">
                  <div className="label">Rol</div>
                  <select className="inputElement roleInput animationLoader" disabled></select>
                </div>
                <div className="firstNameContainer">
                  <div className="label disabled">Nombre</div>
                  <input type="text" className="inputElement animationLoader" disabled />
                </div>
                <div className="lastNameContainer">
                  <div className="label disabled">Apellido</div>
                  <input type="text" className="inputElement animationLoader" disabled />
                </div>
                <div className="emailContainer">
                  <div className="label disabled">Correo</div>
                  <input type="text" className="inputElement animationLoader" disabled />
                </div>
                <div className="phoneContainer">
                  <div className="label disabled">Número de contacto</div>
                  <div className="flagAndNumber">
                    <div className="countryCodeContainer animationLoader" />
                    <input type="text" className="inputElement phoneNumber animationLoader" disabled />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OrganizationLoader;
